<template>
  <b-modal v-model="modalVisible" scrollable centered hide-footer hide-header body-bg-variant="danger" body-text-variant="light">
    <template #default>
      <div>
        <div class="text-center h3">!!警告!!</div>

        <p>目前進行中的流程發生以下的錯誤問題:</p>

        <div class="mb-3">
          <p class="mb-2" v-for="(item, index) in errorKegs" :key="index">
            {{ item.keg.kid }} - {{ item.errorMsg }}
          </p>
        </div>

        <p>確定要繼續執行流程嗎?</p>
        <div class="row">
          <div class="col-6">
            <b-button variant="outline-light" @click="modalVisible = false" class="w-100">取消</b-button>
          </div>
          <div class="col-6">
            <b-button variant="light" @click="continueClicked" class="w-100">繼續</b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'KegAlertModal',
  data() {
    return {
    };
  },
  components: {
  },
  mounted() {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
    kegs: {
      type: Array,
      required: true,
      default: () => [],
      passed: false,
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    errorKegs() {
      return this.kegs.filter(keg => keg.error);
    },  
  },
  watch: {
    
  },
  methods: {
    continueClicked() {
      this.$emit('continue');
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

</style>
